import { bulkInscriptionsHandlers } from './bulkInscription.handler';
import { usersSelectionHandlers } from './usersSelection.handler';
import { questionBankHandlers } from './questionBank.handler';
import { lpActivityReportHandlers } from './lpActivityReport.handler';
import { reportsHandlers } from './reports.handler';
import { myTeamReportHandlers } from './myTeamReport.handler';
import { courseTableHandlers } from './coursesTable.handler';
import { learningPathsHandlers } from './learningPaths.handler';
import { gamificationHandlers } from './gamification.handler';
import { myLearningHandlers } from './myLearning.handler';
import { peopleManagementHandlers } from './peopleManagement.handler';
import { courseCreationAssistantHandlers } from './courseCreationAssistant.handler';
import { reportsCenterHandlers } from './reportsCenter.handler';

export const lmsModuleHandlers = [
  ...bulkInscriptionsHandlers,
  ...usersSelectionHandlers,
  ...questionBankHandlers,
  ...lpActivityReportHandlers,
  ...reportsHandlers,
  ...myTeamReportHandlers,
  ...courseTableHandlers,
  ...learningPathsHandlers,
  ...gamificationHandlers,
  ...myLearningHandlers,
  ...peopleManagementHandlers,
  ...courseCreationAssistantHandlers,
  ...reportsCenterHandlers
];
